export class WorkflowActionConstants {
    static readonly PROCESSING = 'processing';
    static readonly MANAGE_WORK_ORDERS = 'manageWorkOrders';
    static readonly REVERSE_AP_BILL = 'reverseAPBill';
    static readonly RETURN_TO_ACCOUNTANT = 'returnToAccountant';
    static readonly CHANGE_TO_EFT_PAYMENT = 'changeToEFTPayment';
    static readonly UNMARK_EFT_PAYMENT = 'unmarkEFTPayment';
    static readonly CHANGE_SPECIAL_HANDLING = 'changeSpecialHandling';
    static readonly VIEW_DELETE_REASON = 'viewDeleteReason';
    static readonly ATTRIBUTE_COMMUNITY = 'attributeCommunity';
}
